import { getAllDropdowns } from '../../../shared/services/allDropdownsRegistry';

function hasValue(value: unknown): boolean {
  return !(value === null || value === undefined || value === '');
}

/**
 * Returns true when the given MoB value matches the configured dropdown value for label "MoB".
 */
export function isMobDecisionMob(value: unknown): boolean {
  if (!hasValue(value)) {
    return false;
  }

  const mobDropdownValue = getAllDropdowns()?.npi_mob?.find((item) => item.label === 'MoB')?.value;
  if (!hasValue(mobDropdownValue)) {
    return false;
  }

  return Number(value) === Number(mobDropdownValue);
}
